import {combineReducers} from 'redux';
import AirlinesFilterReducer from './filters/AirlinesFilterReducer';
import TranslationsReducer from "./filters/TranslationsReducer";
import FlightsReducer from "./flights/FlightsReducer";
import SocketReducer from "./socket/SocketReducer";
import TransferTimeFilterReducer from "./filters/TransferTimeFilterReducer";
import ParametersReducer from "./ParametersReducer";
import FlightDurationFilterReducer from "./filters/FlightDurationFilterReducer";
import ForwardTimeFilterReducer from "./filters/ForwardTimeFilterReducer";
import ReturnTimeFilterReducer from "./filters/ReturnTimeFilterReducer";
import StopsFilterReducer from "./filters/StopsFilterReducer";
import ArrivalAirportsFilterReducer from "./filters/ArrivalAirportsFilterReducer";
import ReturnAirportsFilterReducer from "./filters/ReturnAirportsFilterReducer";
import StopAirportsFilterReducer from "./filters/StopAirportsFilterReducer";
import BaggageFilterReducer from "./filters/BaggageFilterReducer";
import SortReducer from "./filters/SortReducer";
import FilterGroupsReducer from "./filters/FilterGroupsReducer";
import MatrixReducer from "./matrix/MatrixReducer";
import IdleReducer from "./idle/IdleReducer";
import FareAlertReducer from "./fareAlert/FareAlertReducer";

const Reducers = combineReducers({
    SocketReducer,
    AirlinesFilterReducer,
    TranslationsReducer,
    FlightsReducer,
    TransferTimeFilterReducer,
    ParametersReducer,
    FlightDurationFilterReducer,
    ForwardTimeFilterReducer,
    ReturnTimeFilterReducer,
    StopsFilterReducer,
    ArrivalAirportsFilterReducer,
    ReturnAirportsFilterReducer,
    StopAirportsFilterReducer,
    BaggageFilterReducer,
    SortReducer,
    FilterGroupsReducer,
    MatrixReducer,
    IdleReducer,
    FareAlertReducer
});

export default Reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js